import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAd9JSeXe-6qOk9rIvtc4CFCQFtKK8w7cs",
  authDomain: "fontanini-family.firebaseapp.com",
  projectId: "fontanini-family",
  storageBucket: "fontanini-family.firebasestorage.app",
  messagingSenderId: "914108359052",
  appId: "1:914108359052:web:4a21ba3308bba8f224b6a9"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();